<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  export let label;
  export let name;
  export let iconType;
  export let value = '';
  export let error;
  export let Style;
  export let type = 'text';
  export let placeholder = '';
  export let parentClass;
  export let disabled;
  export let maxLength;
  export let rows = 2;
  let formInput;

  const iconList = {
    email: '/images/email.svg',
    password: '/images/lock.svg',
  };
  const handleInput = (e) => {
    value = e.target.value;
    dispatch('onHandleInput', e);
  };
  export let handleChange = (e) => {
    dispatch('onHandleChange', e);
  };
</script>

<div
  class="form-group mb-3 w-100 position-relative {error ? 'error' : ''} {parentClass} {iconType
    ? 'input-icon'
    : ''}  "
>
  {#if label}
    <label
      for={name}
      class="form-label">{label}</label
    >
  {/if}
  {#if iconType}
    <img
      alt=""
      class="icon-16 position-absolute"
      src={iconList[iconType]}
    />
  {/if}
  {#if maxLength && !(disabled != undefined && disabled == true) && value?.length > 0}
    <span
      class="position-absolute"
      style="font-size: 10px;right:0">{value?.length}/{maxLength}</span
    >
  {/if}
  <textarea
    bind:this={formInput}
    maxLength={maxLength}
    Style={Style}
    disabled={disabled}
    name={name}
    type={type}
    value={value}
    placeholder={placeholder}
    on:input={handleInput}
    on:change={handleChange}
    on:blur
    class="form-control"
    rows={rows}
  />
  {#if error}
    <label
      class="formError"
      for={name}>{error}</label
    >
  {/if}
</div>
<!-- <script>
	export let label;
	export let id;
	export let leftIcon;
	export let value = "";
	export let error;
	export let placeholder = "";
	export let parentClass
	let formInput;

	const handleInput = (e) => {
	 value = e.target.value;
	error = ""
	 };
</script>


<div class="form-group mb-3 w-100 position-relative  {error ? "error" : ''} {parentClass} {leftIcon ? 'input-icon':''}  ">
<label for={id}  class="form-label">{label}</label>
{#if leftIcon}
	<img alt="" class="icon-16 position-absolute " src={leftIcon} />
{/if}
<textarea
	bind:this={formInput}

	{value}
	{placeholder}
	{id}
	on:input={handleInput}
	class="form-control"
/>

	{#if error}
		<label class="formError " for={id}>{error}</label>
	{/if}

</div> -->
